export enum CURRENCY_ENUM {
  RUBLE = "₽",
  TENGE = "₸",
}